<template>
  <v-layout row wrap>
    <!-- <v-flex xs12 sm2 md2 shrink class="hidden-sm-and-down">
        <v-card class="white black--text">
            <lead-list/>
        </v-card>
    </v-flex> -->
    <v-flex xs12 sm12 md12 grow class="scrollkanban">
      <v-flex xs12 sm12 md12>
        <v-card class="white black--text">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row wrap>
                <v-flex xs6 sm3 md2 class="pb-10" v-if="hasSellers">
                  <v-combobox
                    prepend-icon="face"
                    v-model="seller"
                    :items="this.sellers"
                    item-text="email"
                    item-value="email"
                    label="Vendedores"
                    hide-no-data
                    return-object
                  ></v-combobox>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pb-10">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    dark
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="startDateFormatted"
                        label="Data Inicial"
                        persistent-hint
                        prepend-icon="event"
                        @blur="startDate = parseDate(startDateFormatted)"
                        v-on="on"
                        :rules="[
                          (v) => !!v || 'Informe a Data de inicio',
                          (v) => !!validDate(startDate) || 'Data inválida!',
                        ]"
                        mask="##/##/####"
                        return-masked-value
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                  <!-- <p>Date in ISO format: <strong>{{ startDate }}</strong></p> -->
                </v-flex>
                <v-flex xs6 sm3 md2>
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                    mask="##/##/####"
                    dark
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="endDateFormatted"
                        label="Data Final"
                        persistent-hint
                        prepend-icon="event"
                        @blur="endDate = parseDate(endDateFormatted)"
                        v-on="on"
                        :rules="[
                          (v) => !!v || 'Informe a Data de inicio',
                          (v) => !!validDate(endDate) || 'Data inválida!',
                        ]"
                        required
                        mask="##/##/####"
                        return-masked-value
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                  <!-- <p>Date in ISO format: <strong>{{ endDate }}</strong></p> -->
                </v-flex>
                <v-flex xs12 sm3 md2>
                  <v-layout row wrap>
                    <!-- <v-spacer/> -->
                    <v-btn
                      color="success"
                      icon
                      outline
                      small
                      @click="_search"
                      :disabled="!valid || loading"
                      :loading="loading"
                    >
                      <v-icon>search</v-icon>
                    </v-btn>
                    <v-spacer />
                    <v-btn
                      color="tertiary"
                      small
                      outline
                      slot="start"
                      @click="_clear"
                      :disabled="!valid || loading"
                    >
                      <v-icon>clear</v-icon>Limpar
                    </v-btn>
                    <v-spacer />
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm1 md4 class="hidden-sm-and-down">
                  <v-layout row wrap class="pt-2 mt-2">
                    <!-- <v-icon v-if="bySeller.rank === 1" :color="bySeller.rank | rankColor">{{bySeller.rank | rankIcon}}</v-icon>
                                    <v-avatar size="32" left :color="bySeller.rank | rankColor" class="font-weight-bold white--text">{{bySeller.rank}}º</v-avatar> -->
                    <!-- <v-spacer/> -->
                    <v-chip small color="blue" text-color="white">
                      <v-avatar class="blue darken-4 font-weight-bold">{{
                        totalSeller
                      }}</v-avatar>
                      Inscrições
                    </v-chip>
                    <!-- <v-spacer/> -->
                    <!-- <v-chip small :color="bySeller.rank | rankColor" text-color="white">
                                        <v-avatar :class="'${bySeller.rank | rankColor} darken-5 font-weight-bold'">
                                            {{bySeller.rank}}º
                                        </v-avatar>
                                        <v-icon color="#FFF">{{bySeller.rank | rankIcon}}</v-icon>
                                    </v-chip> -->
                    <v-chip small color="blue" text-color="white">
                      <v-avatar class="blue darken-4 font-weight-bold">{{
                        bySeller.average
                      }}</v-avatar>
                      Média
                      <!-- <v-icon right color="white">functions</v-icon> -->
                    </v-chip>
                    <v-chip small color="green" text-color="white">
                      <v-avatar class="green darken-4 font-weight-bold">{{
                        bySeller.top
                      }}</v-avatar>
                      Top
                      <v-icon right color="white">emoji_events</v-icon>
                    </v-chip>
                    <!-- <v-spacer/> -->
                    <v-icon
                      v-if="bySeller.rank === 1"
                      :color="bySeller.rank | rankColor"
                      >{{ bySeller.rank | rankIcon }}</v-icon
                    >
                    <v-icon
                      v-if="
                        bySeller.top > 0 &&
                        (bySeller.rank === 0 || bySeller.rank > 2)
                      "
                      :color="bySeller.rank | rankColor"
                      >{{ bySeller.rank | rankIcon }}</v-icon
                    >
                    <v-avatar
                      size="32"
                      left
                      :color="bySeller.rank | rankColor"
                      class="font-weight-bold white--text"
                      >{{
                        bySeller.top > 0 && bySeller.rank === 0
                          ? ":-("
                          : bySeller.rank + "º"
                      }}</v-avatar
                    >
                    <v-chip small color="orange" text-color="black">
                      <v-avatar class="yellow darken-2 font-weight-bold">{{
                        bySeller.ucs
                      }}</v-avatar>
                      <span class="white--text">UCs</span>
                      <!-- <v-icon right color="white">maps_home_work</v-icon> -->
                    </v-chip>
                    <!-- <v-avatar size="32" left :color="bySeller.rank | rankColor" class="font-weight-bold white--text">{{bySeller.ucs}}</v-avatar> -->
                    <!-- <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                        <v-badge>
                                            <template v-slot:badge>
                                            <span pt-0>{{task.installation_numbers.length}}</span>
                                            </template>
                                            <v-btn icon small round dark  color="#efefef" style=" margin: 0px 2px"
                                            @click.prevent="viewLead(task)"
                                            v-on="on"
                                            >
                                            <v-icon color="black">maps_home_work</v-icon>
                                            </v-btn>
                                        </v-badge>
                                        </template>
                                        <span>Detalhes do Lead</span>
                                    </v-tooltip> -->
                    <!-- <v-chip small label :color="bySeller.rank | rankColor">
                                        <v-icon left :color="bySeller.rank | rankColor">{{bySeller.rank | rankIcon}}</v-icon>{{bySeller.rank}}º rank
                                    </v-chip> -->
                    <!-- <v-chip small :color="bySeller.rank | rankColor" class="darken-4"> -->

                    <!-- </v-chip> -->
                    <!-- <v-btn color="tertiary" small outline slot="start" @click="goToSaleOld" :disabled="!valid || loading">
                                        <v-icon left>gavel</v-icon>Vendas Legado
                                    </v-btn> -->
                  </v-layout>
                </v-flex>
                <v-spacer />
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-flex>
      <!-- <v-item-group>
        <v-container grid-list-md> -->
      <v-layout row style="background: #efefef">
        <v-card
          v-for="column in columns"
          :key="column.title"
          color="#fff"
          style="margin: 6px"
          min-width="350px"
          min-height="100vh"
          class="column"
        >
          <!-- <div class="text-xs-center pa-5 height: 100vh" v-if="loading || loadingLead">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </div> -->
          <v-card-text>
            <v-layout row wrap pb-0>
              <div class="font-weight-bold">
                {{ column.title }}
                <v-btn
                  :loading="loading || loadingLeads"
                  small
                  round
                  dark
                  fab
                  color="blue"
                  style="height: 19px"
                  >{{ column.tasks.length }}</v-btn
                >
              </div>
              <v-spacer />
              <v-icon
                v-if="
                  column.action && column.action.method === 'startSubscription'
                "
                rigth
                @click="setAction(column.action)"
                >add</v-icon
              >
              <v-icon
                v-if="column.action && column.action.method === 'findUser'"
                rigth
                @click="setAction(column.action)"
                >search</v-icon
              >
            </v-layout>
          </v-card-text>
          <v-container
            fluid
            grid-list-sm
            id="scroll-target"
            pt-1
            pb-1
            class="column-scroll"
          >
            <!-- <v-layout row wrap> -->
            <v-layout column align-center justify-center>
              <v-flex xs12 class="col-flex">
                <!-- Draggable component comes from vuedraggable. It provides drag & drop functionality -->
                <!-- <draggable :list="column.tasks" :animation="200" ghost-class="ghost-card" group="tasks"> -->
                <!-- Each element from here will be draggable and animated. Note :key is very important here to be unique both for draggable and animations to be smooth & consistent. -->
                <div v-if="column.type === 'subscriptions'">
                  <lead-card
                    v-for="task in column.tasks"
                    :key="task.uc ? task.uc.id : task.id"
                    :task="task"
                    :showStatus="column.showStatus"
                    :type="column.type"
                    class="mb-3 cursor-move"
                    lazy
                  ></lead-card>
                </div>
                <div
                  v-else-if="
                    column.type === 'qualifications' ||
                    column.type === 'disqualified'
                  "
                >
                  <qualification-card
                    v-for="task in column.tasks"
                    :key="task.uc ? task.uc.id : task.id"
                    :task="task"
                    :showStatus="column.showStatus"
                    :type="column.type"
                    class="mb-3 cursor-move"
                    lazy
                  ></qualification-card>
                </div>
                <div v-else-if="column.type === 'canceled'">
                  <qualification-card
                    v-for="task in column.tasks"
                    :key="task.uc ? task.uc.id : task.id"
                    :task="task"
                    :showStatus="column.showStatus"
                    :type="column.type"
                    class="mb-3 cursor-move"
                    lazy
                  ></qualification-card>
                </div>
                <div v-else>
                  <default-card
                    v-for="task in column.tasks"
                    :key="task.uc ? task.uc.id : task.id"
                    :task="task"
                    :showStatus="column.showStatus"
                    :type="column.type"
                    class="mb-3 cursor-move"
                    lazy
                  ></default-card>
                </div>
                <!-- </transition-group> -->
                <!-- </draggable> -->
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
        <lead-form />
        <!-- <busca-venda/> -->
        <consumer-unit-form />
        <sale-view
          :dialog="dialog_novo_cliente"
          @closeDialog="dialog_novo_cliente = false"
          @showStatusSaleSnack="showStatusSaleSnack"
        />
      </v-layout>
      <!-- subscriptions: {{subscriptions}} -->
    </v-flex>
    <v-snackbar
      :color="snack.color"
      :bottom="snack.bottom"
      :top="snack.top"
      :left="snack.left"
      :right="snack.right"
      v-model="snack.snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.snackMessage }}</div>
      <v-icon size="16" @click="snack.snackbar = false">
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-layout>
</template>
<script>
// import draggable from "vuedraggable";
// import TaskCard from "../../components/sales/kanban/TaskCard";
import LeadCard from "../../components/sales/kanban/LeadCard";
// import LeadList from "../../components/sales/LeadList";
import DefaultCard from "../../components/sales/kanban/DefaultCard";
import QualificationCard from "../../components/sales/kanban/QualificationCard";

import moment from "moment";
import { mapActions, mapState } from "vuex";
import LeadForm from "../../components/sales/LeadForm";
import { eventBus } from "../../main";
import { toDate } from "../../utils/dates";
// import BuscaVenda from '../../components/sales/BuscaVenda'
import ConsumerUnitForm from "../../components/consumerUnits/ConsumerUnitForm";
import { getSellers } from "../../services/users";

export default {
  name: "Kanban",
  components: {
    LeadCard,
    QualificationCard,
    DefaultCard,
    LeadForm,
    ConsumerUnitForm,
    SaleView: () => import("../../components/sales/SaleView"),
  },
  mounted() {
    if (this.user) {
      if (this.salesDay && this.salesDay.length === 0) {
        this.getSalesDay();
      }
      if (this.user && this.user.group && Array.isArray(this.user.group)) {
        if (
          this.user.group.indexOf("admin") >= 0 ||
          this.user.group.indexOf("sales_management") >= 0 ||
          this.user.group.indexOf("sales_partner_management") >= 0
        ) {
          this.getSellers(
            this.user.group.indexOf("sales_partner_management") >= 0
              ? this.user?.partner_id
              : null,
          );
        }
      } else if (this.user && this.user.group) {
        if (
          this.user.group === "admin" ||
          this.user.group === "sales_management" ||
          this.user.group === "sales_partner_management"
        ) {
          this.getSellers(
            this.user.group === "sales_partner_management"
              ? this.user?.partner_id
              : null,
          );
        }
      } else {
        this.seller = this.user;
      }
      if (!this.subscriptions || this.subscriptions?.length < 1) {
        this.getLeadsBySeller({
          email: this.user.email,
          start_date: this.startDate,
          end_date: this.startDate,
        });
      } else {
        this.columns[0].tasks = this.subscriptions;
      }
      if (!this.sales || this.sales?.length < 1) {
        this.getUsersBySeller({
          email: this.user.email,
          start_date: this.startDate,
          end_date: this.endDate,
        });
      } else {
        this.columns[1].tasks = this.qualifications;
        this.columns[2].tasks = this.contracts;
        this.columns[3].tasks = this.active;
        this.columns[4].tasks = this.disqualified;
        this.columns[5].tasks = this.canceled;
        this.columns[6].tasks = this.contractsNotSign;
      }
    }
  },
  data: () => ({
    search: "",
    dialog_novo_cliente: false,
    dialog_search: false,
    dialog_consumer_unit: false,
    startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
    startDateFormatted: moment().subtract(7, "days").format("DD/MM/YYYY"),
    menu1: false,
    endDate: moment().add(1, "days").format("YYYY-MM-DD"),
    endDateFormatted: moment().add(1, "days").format("DD/MM/YYYY"),
    menu2: false,
    valid: true,
    seller: "",
    sellers: [],
    columns: [
      {
        title: "Inscrições",
        type: "subscriptions",
        tasks: [],
        showStatus: false,
        action: {
          method: "startSubscription",
          param: {},
        },
      },
      {
        title: "Qualificação",
        type: "qualifications",
        tasks: [],
        showStatus: true,
      },
      {
        title: "Contrato",
        type: "contracts",
        tasks: [],
        showStatus: true,
        // action: {
        //     method: 'findUser',
        //     param: {}
        // }
      },
      {
        title: "Ativo",
        type: "active",
        tasks: [],
        showStatus: false,
      },
      {
        title: "Desqualificado",
        type: "disqualified",
        tasks: [],
        showStatus: true,
      },
      {
        title: "Cancelado",
        type: "canceled",
        tasks: [],
        showStatus: false,
      },
      {
        title: "Contrato não assinado",
        type: "contractsNotSign",
        tasks: [],
        showStatus: true,
      },
    ],
    snack: {
      color: null,
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackMessage: "",
      snackbar: false,
    },
  }),
  watch: {
    subscriptions(val) {
      return (this.columns[0].tasks = val);
    },
    qualifications(val) {
      return (this.columns[1].tasks = val);
    },
    contracts(val) {
      return (this.columns[2].tasks = val);
    },
    active(val) {
      return (this.columns[3].tasks = val);
    },
    disqualified(val) {
      return (this.columns[4].tasks = val);
    },
    canceled(val) {
      return (this.columns[5].tasks = val);
    },
    contractsNotSign(val) {
      return (this.columns[6].tasks = val);
    },
    startDate(val) {
      if (this.validDate(val)) this.startDateFormatted = this.formatDate(val);
    },
    endDate(val) {
      if (this.validDate(val)) this.endDateFormatted = this.formatDate(val);
    },
  },
  computed: {
    ...mapState("sales", [
      "subscriptions",
      "qualifications",
      "contracts",
      "active",
      "canceled",
      "disqualified",
      "sales",
      "loadingLeads",
      "loading",
      "salesDay",
      "contractsNotSign",
    ]),
    ...mapState(["user"]),
    hasSellers() {
      if (this.user && this.user.group) {
        if (
          Array.isArray(this.user.group) &&
          (this.user.group.indexOf("admin") >= 0 ||
            this.user.group.indexOf("sales_partner_management") >= 0 ||
            this.user.group.indexOf("sales_management") >= 0)
        ) {
          return true;
        } else if (
          this.user.group === "admin" ||
          this.user.group === "sales_management" ||
          this.user.group === "sales_partner_management"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    totalSeller() {
      let _seller = this.user.email;
      if (this.seller !== "") _seller = this.seller.email;
      if (!this.salesDay) return 0;
      return this.salesDay.filter((value) => {
        if (value.signedcontract_partner === _seller) return value;
      }).length;
    },
    bySeller() {
      // console.log('bySeller: ', this.salesDay)
      // console.log(this.totalSeller)
      if (!this.salesDay || this.salesDay.length <= 0)
        return { rank: 0, average: 0, top: 0 };
      var counts = this.salesDay.reduce((p, c) => {
        var name = c.signedcontract_partner;
        if (!p.hasOwnProperty(name)) {
          p[name] = 0;
        }
        p[name]++;
        // p[ucs] = p[ucs] + ucs
        return p;
      }, {});

      // console.log(counts);

      var countsExtended = Object.keys(counts).map((k) => {
        return { seller: k, count: counts[k] };
      });

      let rank = countsExtended.sort(function (a, b) {
        return a.count < b.count ? 1 : a.count > b.count ? -1 : 0;
      });
      let top = rank[0].count;

      let _seller = this.user.email;
      if (this.seller !== "") _seller = this.seller.email;
      if (rank.length <= 0) return 0;
      let _rank = rank.map((cur, idx) => {
        if (cur.seller === _seller) {
          if (idx > 0) {
            // console.log('anterior: ', rank[idx-1])
            if (rank[idx - 1].count === cur.count) return idx;
          }
          return idx + 1;
        } else return 0;
        // if(value.signedcontract_partner === 'rafael.santos@enercred.com') return value
      }, 0);
      _rank = _rank.reduce((cur, sum) => {
        return (sum = sum + cur);
      }, 0);
      // console.log('salesDay: ', this.salesDay.length)
      // console.log('counts.length: ', countsExtended.length)

      let _average = this.salesDay.length / countsExtended.length;

      if (this.seller !== "") _seller = this.seller.email;
      let _ucs = this.salesDay.reduce((acumulador, valorAtual) => {
        let q = 0;
        if (valorAtual.signedcontract_partner === _seller)
          q = valorAtual.installation_numbers
            ? valorAtual.installation_numbers.length
            : 0;
        return acumulador + Number(q);
      }, 0);
      return { rank: _rank, average: _average.toFixed(0), top: top, ucs: _ucs };

      // return rank.reduce((cur, i) => {
      //     console.log(cur)
      //     if(cur.seller === this.user.email) return i
      // },0)
    },
  },
  filters: {
    formatDateOperation(value) {
      if (!value) return "-";
      return moment(value).format("DD/MM/YYYY");
    },
    rankIcon(value) {
      if (!value || value === 0) return "mdi-flashlight";
      else if (value === 1) return "military_tech";
      else if (value === 2) return "stars";
      else if (value === 3) return "star_border";
      else return "mdiFlashlight";
    },
    rankColor(value) {
      if (!value || value === 0) return "red";
      else if (value === 1) return "#d4af37";
      else if (value === 2) return "grey";
      else if (value === 3) return "#cd7f32";
      else return "red";
    },
  },
  methods: {
    ...mapActions("sales", [
      "getUsersBySeller",
      "getLeadsBySeller",
      "getSalesDay",
    ]),
    add(column, data) {
      this.columns[column].tasks.push(data);
    },
    startSubscription: async function () {
      // eventBus.$emit('Lead', {})
      // eventBus.$emit('dialog_novo_cliente', true) // emit the event to the bus
      this.dialog_novo_cliente = true;
    },
    setAction(action) {
      if (!action) console.error("Não há ação definida");
      if (action.method === "startSubscription") this.startSubscription();
      else if (action.method === "findUser") this.findUser();
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    validDate(val) {
      return toDate(val) instanceof Date;
    },
    is_earlier(dtStart, dtEnd) {
      if (!(toDate(dtStart) instanceof Date)) return false;
      if (!(toDate(dtEnd) instanceof Date)) return false;
      if (new Date(dtEnd) < new Date(dtStart)) return false;
      else return true;
    },
    is_between(dtStart, dtEnd) {
      if (!(toDate(dtStart) instanceof Date)) return false;
      if (!(toDate(dtEnd) instanceof Date)) return false;

      if (new Date(dtEnd) - new Date(dtStart) > 5270400000) return false;
      else return true;
    },
    _search() {
      if (!this.seller || this.seller === "") {
        this.seller = this.user;
      }
      if (!this.is_earlier(this.startDate, this.endDate)) {
        this.show_snack(
          "Data final não pode ser anterior a data inicial!",
          "error",
          "top",
        );
        return;
      }
      if (!this.is_between(this.startDate, this.endDate)) {
        this.show_snack(
          "Intervalo não pode ser maior que 60 dias!",
          "error",
          "top",
        );
        return;
      }
      this.columns.map((column, i) => {
        this.columns[i].tasks = [];
      });
      this.getLeadsBySeller({
        email: this.seller.email,
        start_date: this.startDate,
        end_date: this.endDate,
      });
      this.getUsersBySeller({
        email: this.seller.email,
        start_date: this.startDate,
        end_date: this.endDate,
      });
    },
    findUser() {
      eventBus.$emit("dialog_busca_venda", true); // emit the event to the bus
    },
    _clear() {
      this.startDate = moment().subtract(7, "days").format("YYYY-MM-DD");
      this.startDateFormatted = moment()
        .subtract(7, "days")
        .format("DD/MM/YYYY");
      this.menu1 = false;
      this.endDate = moment().add(1, "days").format("YYYY-MM-DD");
      this.endDateFormatted = moment().add(1, "days").format("DD/MM/YYYY");
      this.menu2 = false;
      this.seller = "";
      this._search();
    },
    goToSaleOld() {
      this.$router.push({ path: "/vendas/antiga" });
    },
    getSellers(partner_id) {
      getSellers(partner_id)
        .then((sellers) => {
          sellers.docs.map((seller) => {
            const data = {
              id: seller.id,
              ...seller.data(),
            };
            this.sellers.push(data);
          });
        })
        .catch((err) => {
          console.error("Erro ao buscar vendedores. ", err);
        });
    },
    show_snack(message, color, ...args) {
      this.snack.top = true;
      this.snack.bottom = false;
      this.snack.left = false;
      this.snack.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snack.color = color;
      this.snack.snackMessage = message;
      this.snack.snackbar = true;
    },
    showStatusSaleSnack(sold, text) {
      this.getLeadsBySeller({
        email: this.user.email,
        start_date: this.startDate,
        end_date: this.endDate,
      });
      this.getUsersBySeller({
        email: this.user.email,
        start_date: this.startDate,
        end_date: this.endDate,
      });
      if (sold) {
        this.show_snack(
          `Venda realizada com sucesso! ${text || ""}`,
          "green",
          "top",
        );
      } else {
        this.show_snack("Erro ao realizar venda.", "error", "top");
      }
    },
  },
};
</script>

<style scoped>
.column-width {
  min-width: 320px;
  width: 320px;
}
/* .column {
    height: 100vh;
} */
/* Unfortunately @apply cannot be setup in codesandbox, 
but you'd use "@apply border opacity-50 border-blue-500 bg-gray-200" here */
.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
div.scrollkanban {
  background-color: #333;
  overflow: auto;
  background: #efefef;
  /* overflow-wrap: break-word;
  white-space: nowrap; */
  max-height: 84vh;
  /* height: 100vh;  */
}
::-webkit-scrollbar {
  width: 15px;
  min-height: 20px !important;
}

::-webkit-scrollbar-track {
  background: #fff;
  border-left: 1px solid #fff;
}

::-webkit-scrollbar-thumb {
  background: #38383859 !important;
  border: solid 3px #fff;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #cccccc !important;
}

.col-flex {
  max-height: 90vh;
}
.column-scroll {
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
